import React from 'react';
import '../messages/MessengerDmMessages.css';
import './MessengerComposerLayout.css';

export function MessengerComposerLayout({
  onSubmit,
  previewZone,
  replyStrip,
  noticeSlot,
  leadingSlot,
  textarea,
  trailingSlot,
  bulkSelectionBar,
}: {
  onSubmit: (e: React.FormEvent) => void;
  previewZone?: React.ReactNode;
  replyStrip?: React.ReactNode;
  /** Пояснение над полем ввода (блокировка, лимиты и т.п.) */
  noticeSlot?: React.ReactNode;
  /** Режим множественного выбора: та же `chatAssistant__inputArea`, нижняя строка — бар выбора */
  bulkSelectionBar?: React.ReactNode;
  leadingSlot?: React.ReactNode;
  textarea?: React.ReactNode;
  trailingSlot?: React.ReactNode;
}): React.ReactNode {
  return (
    <form className="chatAssistant__inputArea" onSubmit={onSubmit}>
      {previewZone}
      {replyStrip}
      {noticeSlot}
      {bulkSelectionBar != null ? (
        <div className="chatAssistant__inputRow chatAssistant__inputRow_bulkBar bulkSelectionToolbar__row">
          {bulkSelectionBar}
        </div>
      ) : (
        <div className="chatAssistant__inputRow">
          {leadingSlot ? <div className="chatAssistant__attachWrap">{leadingSlot}</div> : null}
          {textarea}
          {trailingSlot}
        </div>
      )}
    </form>
  );
}
